import type { ParticipantsCardProps } from "../_model";
// import SendIcon from "../assets/icons/send-2.svg";
import { request } from "../apis";
import { global } from ":shared/app";
import { Button } from ":ui/form";

export default function ParticipantsCard(props: ParticipantsCardProps) {
  const badge = global.store.actions.flavors.getBadgeStyle({ track: props.details?.track });
  const details = props.details;
  const team_info = props.team_info;

  async function onSendInvite() {
    const requester_email = global.api.auth.events.getUserEmail();
    const data = {
      requester_email: requester_email,
      receiver_email: details.email,
      status: "pending",
    };
    return await request.post(JSON.stringify(data)).then(() => {
      global.store.actions.toast.pushToast({
        type: "success",
        message: "Invite Sent",
      });
    });
  }

  return (
    <div class="flex flex-col w-full min-h-300px h-300px max-h-300px bg-bg px-3 py-2 border-1 border-solid border-border-card rounded-md">
      <section class="flex flex-row w-full min-h-110px h-110px max-h-110px gap2 items-center overflow-hidden">
        <div class="flex flex-col min-w-110px w-110px max-w-110px min-h-full h-full">
          <img
            class="w-full h-full rounded-full object-cover "
            src={details?.image ?? "/images/placeholders/person.png"}
            alt="img"
            loading="lazy"
          />
        </div>
        <div class="flex flex-col py1 overflow-hidden">
          <p class="flex flex-row w-full text-black font-bold text-18px mb-1 overflow-x-auto whitespace-nowrap overflow-x-auto ">
            {details?.first_name || details?.last_name
              ? `${details?.first_name || ""} ${details?.last_name || ""}`
              : "No name"}
          </p>
          <span class="text-13px text-brand-gray">
            {details?.reference2 != undefined ? `#${details?.reference2}` : "no reference"}
          </span>
          <button
            //
            class="!px-5px !py-5px form-btn !w-fit !h-fit mt-1"
            onclick={() => window.open(details?.portfolio, "_blank")}
            disabled={details?.portfolio == undefined || details?.portfolio?.length <= 0}
          >
            <div class="i-material-symbols:globe w-20px h-20px"></div>
          </button>
        </div>
      </section>
      <p
        style={badge.style}
        class="capitalize w-fit bg-badge-bg text-badge-text text-12px px-2 my-2 rounded-md self-start"
      >
        {details?.track ?? "no track"}
      </p>
      <p class="w-full h-full text-14px text-text-alt  text-start overflow-auto mt-1 mb-2">
        {details?.bio == undefined || details?.bio?.length <= 0 ? "No bio" : details.bio}
      </p>

      <Button
        //
        controls={{}}
        class={"form-btn !my-1 disabled:(!bg-error-shade text-error)"}
        triggers={{
          // manualStatus: "invalid",
          manualStatus: team_info == undefined ? "invalid" : "valid",
        }}
        onSubmit={(e) => {
          return onSendInvite();
        }}
        // disabled={team_info == undefined || details.team != undefined}
        statusInvalid={"Part Of Team " + String(details?.team)}
        statusValid="Send Invitation"
      />
    </div>
  );
}
